import { makeAutoObservable } from 'mobx'
import { CHAR_MAX_LENGTH } from 'shared/constants/limits'

type INameInputStoreProps = {
  focusOnMount?: boolean
  limit?: number
  name?: string
  isResetErrorOnChange?: boolean
}

export class NameInputStore {
  private _focusOnMount = false
  private _limit = CHAR_MAX_LENGTH
  private _name = ''
  private _error = ''
  readonly isResetErrorOnChange: boolean | undefined = undefined

  constructor(props?: INameInputStoreProps) {
    if (props?.focusOnMount) {
      this._focusOnMount = props.focusOnMount
    }

    if (props?.limit) {
      this._limit = props.limit
    }
    if (props?.name) {
      this.init(props.name)
    }
    if (props?.isResetErrorOnChange) {
      this.isResetErrorOnChange = props.isResetErrorOnChange
    }

    makeAutoObservable(this)
  }

  get name() {
    return this._name
  }

  get error() {
    return this._error
  }

  get focusOnMount() {
    return this._focusOnMount
  }

  get limit() {
    return this._limit
  }

  setName = (value: typeof this._name) => {
    if (this.isResetErrorOnChange) {
      this._error = ''
    }
    this._name = value.slice(0, this._limit)
  }

  setError = (value: typeof this._error) => {
    this._error = value
  }

  init = (name: string) => {
    this.setName(name.slice(0, this._limit))
  }

  checkValidate = (emptyError = 'Add name') => {
    let validate = true
    if (this.error) {
      validate = false
    }
    if (!this.name) {
      validate = false
      this.setError(emptyError)
    }
    return validate
  }
}
